<script>
import { defineComponent, computed, getCurrentInstance } from 'vue'
import Checkbox from '@/components/Input/Checkbox.vue'
import FormItem from '@/components/Input/FormItem.vue'
import BundleItemInput from './BundleItemInput.vue'
import { ValidationProvider } from 'vee-validate'
import BundleTypeInput from './BundleTypeInput.vue'
import route from '@/router'

/**
 * @typedef {import('@/types/product').ProductFormModel} ProductFormModel
 */

/**
 * Define component
 */
export default defineComponent({
  components: {
    Checkbox,
    FormItem,
    BundleItemInput,
    ValidationProvider,
    BundleTypeInput,
},
  props: {
    value: {
      // /** @type {import('@/types/product').ProductBundle} */
      type: [Object],
      default: () => null,
    },
    product: {
      // /** @type {import('vue').PropType<ProductFormModel} */
      type: Object,
      required: true,
    },
    businessId: {
      type: String,
      default: '',
    },
    business: {
      type: Object,
      required: true,
    },
    inventories: {
      type: Array,
      default: () => [],
    },
    errorBundling: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { $confirm } = getCurrentInstance().proxy.$root

    const isProductBundling = computed(() => !!props.value?.type)
    const toggleIsProductBundling = () => {
      if (isProductBundling.value &&  props.value?.bundles?.length) {
        return $confirm({
          title: 'Hapus Bundling',
          content: 'Jika Anda rubah, daftar produk bundling akan terhapus lho, apakah Anda yakin?',
          onOk: () => {
            emit('input', {
              type: isProductBundling.value ? null : (props.value?.type || 'SOFT'),
              bundles: isProductBundling.value ? [] : props.value?.bundles,
            })
          },
        })
      }

      emit('input', {
        type: isProductBundling.value ? null : (props.value?.type || 'SOFT'),
        bundles: isProductBundling.value ? [] : props.value?.bundles,
      })
    }

    const onBundleItemInput = (values) => {
      emit('input', {
        ...props.value,
        bundles: values,
      })
    }

    const isRedeemProductRoute = computed(() => {
      const currentRoute = route.app._route
      return currentRoute.name?.includes('redeem-product-channel') ||
             currentRoute.path?.includes('redeem-product-channel/')
    })

    return {
      isProductBundling,
      toggleIsProductBundling,
      onBundleItemInput,
      isRedeemProductRoute,
    }
  },
})
</script>

<template>
  <div v-if="!isRedeemProductRoute">
    <FormItem>
      <Checkbox
        :value="isProductBundling"
        :disabled="!!$route.query.id"
        label="Product Bundling"
        @input="toggleIsProductBundling"
      />
    </FormItem>

    <div v-if="isProductBundling">
      <div class="mb-1">
        <FormItem>
          <BundleTypeInput v-model="value.type" />
        </FormItem>
      </div>

      <ValidationProvider
        v-slot="{ errors }"
        tag="div"
        rules="required"
        name="Bundling item"
        style="max-width: 700px"
      >
        <div v-if="errors.length" class="ant-form-explain text-danger mb-2">
          {{ errors[0] }}
        </div>
        <BundleItemInput
          :value="value.bundles"
          :business-id="businessId"
          :business="business"
          :product="product"
          :inventories="inventories"
          :error-bundling="errorBundling"
          @input="onBundleItemInput"
          @err="e => $emit('err', e)"
        />
      </ValidationProvider>
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
